import { render, staticRenderFns } from "./top3.vue?vue&type=template&id=93ff78a8&"
import script from "./top3.vue?vue&type=script&lang=js&"
export * from "./top3.vue?vue&type=script&lang=js&"
import style0 from "./top3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports